import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslationService } from '@scripts/woo_services.module/TranslationService';
import { ModalService } from '@src/shared/modal/modal.service';
import { ToFormGroup } from '../../../utils/types';
import { validateRequired } from '../../../utils/validators';
import { CampaignService } from '../../../woo_services.module/CampaignService';
import { Campaign } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'update-ongoing-campaign-name',
  templateUrl: './update-ongoing-campaign-name.component.html',
  standalone: false,
})
export class UpdateOngoingCampaignName implements OnChanges {
  translationService = inject(TranslationService);
  @Input() campaign: Campaign;
  @Output() onAbort = new EventEmitter<void>();
  @Output() onSuccess = new EventEmitter<void>();

  form: FormGroup<ToFormGroup<FormModel>>;

  constructor(private fb: FormBuilder, private campaignService: CampaignService, private modalService: ModalService) {
    this.form = this.fb.group({
      name: new FormControl(null, validateRequired()),
    });
  }

  ngOnChanges(): void {
    this.setNameValue(this.campaign.name);
  }

  submit = (): void => {
    this.setNameValue(this.form.value.name.trim());
    this.modalService
      .openConfirm({
        title: 'Redigering av startad kampanj',
        texts: [
          'Du försöker nu att uppdatera en startad kampanj i WOO Manager. Detta innebär att att den kommer att skickas till adservern automatiskt om du godkänner nedan.',
          'Vill du genomföra ändringarna på kampanjen?',
        ],
        confirmLabel: 'Ja, uppdatera!',
        cancelLabel: 'Nej, jag ångrar mig',
      })
      .then((response) => {
        if (!response.confirm) return;

        const loaderModal = this.modalService.openLoader('Uppdaterar kampanj');
        this.campaignService
          .updateOngoingCampaignName(this.campaign.id, this.form.value.name)
          .then(
            () => {
              this.campaign.name = this.form.value.name;
              this.onSuccess.emit();
              this.modalService.openSuccess('Din kampanj är nu uppdaterad.');
            },
            (error) => {
              console.error('Failed updating campaign: ', error);
              this.modalService.openError(
                'Ajdå, något gick snett! Kunde inte uppdatera kampanj.',
                this.translationService.convertError(error.error.error),
              );
              loaderModal.close();
            },
          )
          .finally(() => {
            loaderModal.close();
          });
      })
      .catch(() => null); // confirmation aborted
  };

  abort = (): void => {
    this.setNameValue(this.campaign.name);
    this.onAbort.emit();
  };

  private setNameValue(value: string) {
    this.form.patchValue({ name: value }, { onlySelf: true, emitEvent: false });
  }
}

interface FormModel {
  name: string;
}
